import { BrandPaginationProps } from "./BrandPaginationTop"
import Pagination from "~/components/ui/Pagination"

export const BrandPaginationBottom = ({ page, url }: BrandPaginationProps) => {
  const pageInfo = page.pageInfo

  return (
    <div className='bg-neutral-200 rounded h-[47px] flex items-center justify-center'>
      <Pagination url={url} pageInfo={pageInfo} />
    </div>
  )
}
